import React from "react";
import Paragraph from "./custom-ui/Paragraph";
import PrimaryHeading from "./custom-ui/PrimaryHeading";

// Disclosure component that provides information about investing in Dunce Coin
const Disclosure = () => {
  return (
    <div
      id="disclosure"
      className="2xl:max-w-[1296px] xl:max-w-[1240px] lg:px-5 md:px-8 px-5 mx-auto container lg:mb-20 2xl:mb-[110px] lg:mt-20 2xl:mt-[110px] xl:pb-20 2xl:pb-[60px]"
    >
      {/* Outer container with maximum width and padding */}
      <div className="xl:pt-[60px] xl:pb-0 py-[70px] lg:max-h-[501px] lg:px-5 xl:px-0">
        {/* Inner container with styling for center alignment, border, and shadow effects */}
        <div className="pt-[47px] md:pt-0 px-7 md:px-5 lg:px-0 flex flex-col justify-center items-center text-center md:min-h-[400px]  xl:min-h-[501px] bg-pink-bg border-dark-purple border-4 w-full 2xl:shadow-xlPurpleShadow xl:shadow-lgPurpleShadow shadow-mdPurpleShadow md:rounded-28 rounded-2xl">
          {/* PrimaryHeading component for the main title */}
          <PrimaryHeading className="text-white" children="Disclosure" />
          {/* Paragraph component with information about the risks of investing in Dunce Coin */}
          <Paragraph
            className="sm:pt-8 text-white pt-4 max-w-[840px] roboto-wide mx-auto font-roboto !font-medium leading-158 !text-base md:!text-2xl md:pb-10 sm:pb-7 pb-4"
            children="Investing in cryptocurrency involves risk, and Dunce Coin is no exception. Ensure you conduct thorough research and understand the risks involved. "
          />
          {/* Paragraph component with additional information and a call to action */}
          <Paragraph
            className="pb-[26px] md:pb-0 max-w-[850px] roboto-wide mx-auto font-roboto !font-medium text-white leading-158 !text-base md:!text-2xl"
            children="Dunce Coin is a playful take on the crypto market but always prioritize informed decision-making. For more details, refer to our comprehensive disclosure document and stay safe while enjoying the fun ride with Dunce Coin!"
          />
        </div>
      </div>
    </div>
  );
};

export default Disclosure;
